import { render } from "./ProfileMarkSubpage.vue?vue&type=template&id=2c9f5f89&scoped=true"
import script from "./ProfileMarkSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileMarkSubpage.vue?vue&type=script&lang=js"

import "./ProfileMarkSubpage.vue?vue&type=style&index=0&id=2c9f5f89&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9f5f89"]])

export default __exports__